import { Component, Vue } from 'vue-property-decorator'

@Component
export class Pagination extends Vue {
  public pageSize: number = 10
  public currentPage: number = 1
  public total: number = 0
  public tableDataList: any[] = []
  public nowPage: number = 0

  handleSizeChange (pageSize: number): void {
    let _that: any = this
    _that.pageSize = pageSize
    _that.nowPage = (_that.currentPage - 1) * _that.pageSize
    _that.isPaginationForPage = true
    _that.getTableDataList()
  }

  handleCurrentChange (currentPage: number): void {
    let _that: any = this
    _that.currentPage = currentPage
    _that.nowPage = (_that.currentPage - 1) * _that.pageSize
    _that.isPaginationForPage = true
    _that.getTableDataList()
  }
}
